import NotificationIndexPage from '../../components/pages/notifications/NotificationIndexPage.vue'
export default {
  components: { NotificationIndexPage }
}
